import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { Button } from '@components/index';
import { fonts } from '@theme/fontsCustomer';

export const Container = styled(Box)`
  width: 100%;
  height: calc(100vh - var(--employee-gnb-height) - 80px);
  margin-left: 292px;
  overflow: auto;
`;

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  ${fonts.Headline3};
  color: ${({ theme: { colors } }) => colors['text-gray-main']};
  align-items: center;
  gap: 12px;
  margin-bottom: 42px;
`;

export const Body = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const TitleHeader = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 11px;

  & .title {
    ${fonts.Headline7};
    color: ${({ theme: { colors } }) => colors['text-gray-main']};
  }

  & .edit {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
  }
`;

export const Frame = styled(Box)`
  background-color: ${({ theme: { colors } }) => colors['bg-white']};
  border: 1px solid ${({ theme: { colors } }) => colors['border-gray-lighter']};
  border-radius: 5px;
  margin-bottom: 31px;
`;

export const ProcessFrame = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: ${({ theme }) => theme.colors['bg-white']};
  border: 1px solid ${({ theme }) => theme.colors['border-gray-lighter']};
  border-radius: 5px;
  padding: 20px;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.02), 0px 0px 3px 0px rgba(0, 0, 0, 0.07);
`;

export const Columns = styled(Box)`
  display: flex;
  flex-direction: row;
`;

export const Column = styled(Box)<{ divide: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  padding: 15px 0px 15px 20px;
  gap: 2px;
  border-bottom: 1px solid ${({ theme: { colors } }) => colors['border-gray-w-lighter']};
  border-right: ${props => props.divide && `1px solid`} ${({ theme: { colors } }) => colors['border-gray-w-lighter']};
  & .content-name {
    ${fonts.Headline9};
    color: ${({ theme: { colors } }) => colors['text-gray-sub-dark']};
  }
  & .content-value {
    ${fonts.Headline8};
    color: ${({ theme: { colors } }) => colors['text-gray-main']};
  }
  & .inquiry {
    ${fonts.Paragraph5};
    color: ${({ theme: { colors } }) => colors['text-gray-main']};
    white-space: pre-line;
  }
`;

export const ProcessSection = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & .process-label {
    ${fonts.Body2};
    font-weight: 700;
    color: ${({ theme }) => theme.colors['text-gray-main']};
  }
`;

export const ButtonSection = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const ButtonSection2 = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
`;

export const ActionButtonGroup = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 0;
  border: 1px solid ${({ theme }) => theme.colors['border-gray-light']};
  border-radius: 3px;
  overflow: hidden;
`;

interface ActionButtonProps {
  selected?: boolean;
}

export const ActionButton = styled(Button)<ActionButtonProps>`
  border-radius: 0;
  border: none;
  width: 247px;
  height: 48px;

  ${({ selected, theme }) =>
    selected &&
    `
    background-color: ${theme.colors['bg-primary']};
    color: ${theme.colors['text-white']};
    
    &:hover {
      background-color: ${theme.colors['bg-primary-dark']};
    }
  `}

  &:not(:last-child) {
    border-right: 1px solid ${({ theme }) => theme.colors['border-gray-light']};
  }
`;

export const ProcessButton = styled(Button)`
  width: 61px;
  height: 40px;

  &:disabled {
    background-color: ${({ theme }) => theme.colors['bg-gray-light']};
    color: ${({ theme }) => theme.colors['text-gray-light']};
  }
`;
